import { render } from "./PreferedProducts.vue?vue&type=template&id=125ae360&scoped=true"
import script from "./PreferedProducts.vue?vue&type=script&lang=js"
export * from "./PreferedProducts.vue?vue&type=script&lang=js"

import "./PreferedProducts.vue?vue&type=style&index=0&id=125ae360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125ae360"]])

export default __exports__